import { Component, OnInit } from '@angular/core';
import { parseZone } from 'moment';
import { AppService } from 'src/app/app.service';
import { GridColumn, GridColumnTypeEnum } from 'src/app/models/common/grid-column.models';
import { SidebarTypeEnum } from 'src/app/models/common/sidebar-type.enum';
import { Warehouse } from 'src/app/models/common/warehouse.model';
import { ModelColorSize } from 'src/app/models/photographer/create-order.model';
import { PhotographerStyle } from 'src/app/models/photographer/photographer-style.model';
import { CommonService } from 'src/app/services/common.service';
import { PhotographerService } from 'src/app/services/photographer.service';
import { AutocompleteSettings } from 'src/app/shared/models/autocomplete-settings.model';
import { UtilitiesService } from 'src/app/shared/services/utilities.service';
import { UtilityFunctions } from 'src/app/shared/utilities/functions.models';

@Component({
  standalone: false,
  selector: 'bt-shooting-list',
  templateUrl: './shooting-list.component.html',
  styleUrls: ['./shooting-list.component.scss']
})
export class ShootingListComponent implements OnInit {

  public warehouses: { data?: Warehouse[], selected?: Warehouse, page?: number, search?: string, autocompleteSettings: AutocompleteSettings, loaderId: string } = {
    autocompleteSettings: new AutocompleteSettings({
      textProperty: 'warehouseFullName',
      valueProperty: 'warehouseId',
      serverPagination: true,
      paginationSize: 50
    }),
    loaderId: UtilityFunctions.newGuid()
  };
  public stylesQty = 1;
  public maxItems: number;
  public loaderId = UtilityFunctions.newGuid();
  public styles: { data?: PhotographerStyle[], total?: number } = {};
  public gridColumns: GridColumn[];
  public gridColumnTypeEnum = GridColumnTypeEnum;
  public currentSidebarType: SidebarTypeEnum;
  public sidebarTypeEnum = SidebarTypeEnum;

  private inputTimeout: any;

  constructor(
    private photoService: PhotographerService,
    private commonService: CommonService,
    private appService: AppService,
    private utilitiesService: UtilitiesService
  ) {
    this.setGridColumns();
  }

  public ngOnInit() {
    this.getMaxItems();
  }

  public onOpenWarehousesAutocomplete() {
    if (!this.warehouses.data) this.getWarehouses(0);
  }

  public onSelectWarehouse(wh: Warehouse) {
    this.warehouses.selected = wh;
    !!wh ? this.getStylesToShoot() : this.styles.data = null;
  }

  public getStylesToShoot() {
    if (this.warehouses.selected) {
      this.photoService.getStylesToShoot(this.warehouses.selected.id, 0, this.stylesQty, null, this.loaderId)
        .subscribe(data => this.styles.data = data);
    }
  }

  public onPlaceOrder() {
    this.currentSidebarType = SidebarTypeEnum.customSidebar
  }

  public placeOrder() {
    this.currentSidebarType = null;
    const rows = [];
    // const rows = this.styles.data.slice(0, this.stylesQty).map(x => {
    //   colorId: x.colorId,
    //   modelId: x.modelId,
    //   sizeGroupId: x.sizeGroupId || null,
    //   shotTypeId: x[0].shotTypeId,
    //   aspectRatioId: x[0].aspectRatioId,
    //   mediaFormatId: x[0].mediaFormatId,
    //   codifiedUsedId: x[0].codifiedUsedId
    // });
    this.commonService.createOrder(
      this.appService.photographerId,
      this.warehouses.selected.id,
      rows as Array<ModelColorSize>,
      parseZone(null).utc(true).toISOString(),
      null,
      null,
      this.loaderId
    ).subscribe(() => {
      this.getStylesToShoot();
    });
  }

  public onChangeStylesQty() {
    clearTimeout(this.inputTimeout);
    this.inputTimeout = setTimeout(() => {
      if (this.stylesQty > this.maxItems || this.stylesQty < 1) {
        this.utilitiesService.showSnackbar('Number of products must be between 1 and ' + this.maxItems.toString());
        this.stylesQty = this.maxItems;
      }
      if (this.stylesQty) this.getStylesToShoot();
    }, 750);
  }

  public onClickStylesQty(n: number) {
    this.stylesQty = this.stylesQty + n;
    clearTimeout(this.inputTimeout);
    this.inputTimeout = setTimeout(() => {
      this.getStylesToShoot();
    }, 750);
  }

  public getWarehouses(page: number) {
    this.warehouses.page = page;
    const size = this.warehouses.autocompleteSettings.paginationSize;
    this.commonService.getWarehouses(page, size, this.warehouses.search, this.warehouses.loaderId).subscribe(data => {
      this.warehouses.data = !page ? data : this.warehouses.data.concat(data);
    });
  }

  public onWarehousesFilterChange(search: string) {
    this.warehouses.search = search;
    this.getWarehouses(0);
  }

  private setGridColumns() {
    this.gridColumns = [
      { title: '', field: '', type: GridColumnTypeEnum.ranking, width: 30 },
      { title: 'Brand', field: 'brandName', type: GridColumnTypeEnum.default },
      { title: 'Category', field: 'categoryName', type: GridColumnTypeEnum.default },
      { title: 'Style', field: 'fullName', type: GridColumnTypeEnum.default },
      { title: 'Color', field: 'colorFullName', type: GridColumnTypeEnum.default },
      { title: 'Size group', field: 'sizeGroupName', type: GridColumnTypeEnum.custom },
      { title: 'Shots', field: 'shotTypeQty', type: GridColumnTypeEnum.default }
    ];
  }

  private getMaxItems() {
    this.photoService.getPhotographerMaxItems(this.loaderId).subscribe(data => {
      this.maxItems = data;
      this.stylesQty = data;
    });
  }
}
